module.exports = __webpack_public_path__ + "static/media/purple rose.bb212972.jpg";